<template>
  <v-app>

    <!-- <m-snackbars></m-snackbars> -->

    <v-navigation-drawer
      fixed
      :mini-variant="miniVariant"
      :width = 240
      :mini-variant-width = 80
      :clipped="clipped"
      v-model="drawer"
      app
    >
    <div class="ma-4">
      <v-img class="ma-1" v-if="miniVariant" src="img/helpcare/logo-small.svg"/>
      <v-img class="ma-4" v-if="!miniVariant" src="img/helpcare/logo.svg"/>
    </div>


      <m-navigation></m-navigation>

      <template v-slot:append>
        <v-list-item>
          <v-list-item-content>
              <m-language></m-language>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <v-app-bar class="elevation-1" fixed app :clipped-left="clipped" :color="$socket.connected ? 'primary' : 'black'" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <v-toolbar-title>

      </v-toolbar-title>



      <v-spacer></v-spacer>
      <m-search global solo hide-details></m-search>
      <m-demands></m-demands>
      <m-sounds-btn></m-sounds-btn>
      <m-messages v-if="role.can(user.role, 'mail')"></m-messages>


      <v-btn icon @click.stop="rightDrawer = !rightDrawer">
        <v-icon>settings</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container fill-height fluid>
        <v-slide-y-transition mode="out-in">
          <v-layout align-center style="max-width:100%" >

            <slot v-show="$socket.connected"></slot>
            <div v-show="!$socket.connected">Not connected (Please refresh)</div>
          </v-layout>

        </v-slide-y-transition>
      </v-container>
    </v-main>
    <v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
    >
      <v-list>
        <v-list-item :to="{name: 'settings'}">
          <v-list-item-action>
            <v-icon>settings</v-icon>
          </v-list-item-action>
          <v-list-item-title >settings</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'logout'}">
          <v-list-item-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-action>
          <v-list-item-title >log off</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

      <v-footer class="primary" :fixed="fixed" app height="20px">
        <v-layout>
          <v-flex xs12 >
            <div class="white--text text-right">
              <span class="h4yIcon h4yIcon-logo-hart-black pr-2"></span> <span class="white--text">&copy; 2021</span>
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
  </v-app>
</template>

<script>
  import MDemands from '@/components/demands/demandsList.vue'
  import Messages from '@/components/mail/messages.vue'
  import MNavigation from '@/components/navigation.vue'
  import MLanguage from '@/components/common/language.vue'
  import MSearch from '@/components/search/e-search'
  import MSoundsBtn from '@/components/common/audio/soundsbtn'
  import MSocket from '@/core/socket'
  // import MSnack from "@/components/notification/snackbars";
  import Auth from '@/core/auth';
  import MRole from '@/core/roles'


  export default {
    mixins: [MSocket],
    components: {
      'm-navigation': MNavigation,
      'm-language': MLanguage,
      'm-messages': Messages,
      'm-sounds-btn': MSoundsBtn,
      'm-demands': MDemands,
      //"m-snackbars": MSnack,
      'm-search': MSearch
    },
    data () {
      return {
        clipped: false,
        drawer: true,
        fixed: true,
        miniVariant: false,
        right: true,
        rightDrawer: false,
        role: MRole,
        title: 'Dispatcher'
      }
    },
    computed: {
      user: Auth.getUser
    }
  }
</script>
<style lang="scss">
  .item-group{
    padding: 20px 0 10px 20px;

  }
  .v-list__group__items{
    display: block;
    .child {
      &.v-list-item__link {
        padding: 0 30px;
      }
    }
  }
  .v-application {
    .m-title {
      color: grey;
      font-weight: 500;
      min-height: 25px;
      padding: 0 16px;
    }
    .v-footer, .footer {
      min-height: 15px !important;
      font-size: 10px;
      padding: 0px 16px;
    }
    .v-icon.v-icon {
      vertical-align: text-bottom;
    }
    .container {
      padding: 24px;
    }
    .m-page__title {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      padding: 16px;
      font-size: 14px;
      padding-bottom: 24px;
    }
  }


</style>
